namespace GeniuzPOS.ReportMasterData {
    export interface Report_1413Form {
    }

    export class Report_1413Form extends Serenity.PrefixedContext {
        static formKey = 'ReportMasterData.Report_1413';
    }
}
